import Api, { FetchMethodType } from 'api/Api';

export interface PrepopulatedDataResponse {
  externalId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
  middleInitial?: string;
  unit?: string;
}

export type PrefillPrepopulatedDataResponse =
  | {
      success: true;
      data: PrepopulatedDataResponse;
    }
  | { success: false; data: null };

export default class PreFillApi extends Api {
  // [TODO] Add types to consts
  public async getPreFillExperianData(
    externalId: string,
  ): Promise<PrefillPrepopulatedDataResponse> {
    return this.fetch<PrefillPrepopulatedDataResponse>(`/pre-fill/experian/${externalId}`, {
      method: FetchMethodType.GET,
    });
  }
}
